import { useEffect, useState } from 'react';
import axios from 'axios';
import endpoints from '../define/endpoints';
import { camelizeKeys } from 'humps';

export function useCoreLanguageCodes() {
  const [languages, setLanguages] = useState([]);
  useEffect(() => {
    (async function () {
      const { data } = await axios.get(`${endpoints.core}/language-codes`, {
        params: { locale: window.freedomeConfig.locale }
      });
      setLanguages(data);
    })();
  }, []);
  return languages;
}

export function getCoreLanguageCode(selectedLanguageId) {
  const [language, setLanguage] = useState(null);
  useEffect(() => {
    (async function () {
      if (selectedLanguageId) {
        const { data } = await axios.get(
          `${endpoints.core}/language-codes/${selectedLanguageId}`,
          {
            params: { locale: window.freedomeConfig.locale }
          }
        );
        setLanguage(camelizeKeys(data));
      }
    })();
  }, [selectedLanguageId]);
  return language;
}
